import type { AxiosInstance } from 'axios';
import type { RequestEmailChangeDto, ResetPasswordRequestDto } from '../assets/forms/form-schemes.ts';
import type { IsoDate, Nullable } from './types.ts';

export class AuthApi {
  constructor(private instance: AxiosInstance) {

  }

  public async login(dto: LoginDto) {
    return this.instance.post<TokenResponseDto>('/auth/login', dto).then(res => res.data);
  };

  public async logout() {
    const refresh_token = localStorage.getItem('refresh_token');
    return this.instance.post<void>('/auth/logout', {
        refresh_token,
      },
    );
  }

  public async passwordResetRequest(dto: ResetPasswordRequestDto) {
    return this.instance.post<void>('/auth/password-reset-link/request', dto).then(res => res.data);
  }

  public async requestEmailChange(dto: RequestEmailChangeDto) {
    return this.instance.post<MessageResponseDto>('/auth/email/change/request', dto).then(res => res.data);
  }

  public async confirmEmailChange(dto: EmailChangeTokenDto) {
    return this.instance.post<MessageResponseDto>('/auth/email/change/confirm', dto).then(res => res.data);
  }

  public async cancelEmailChange(dto: EmailChangeTokenDto) {
    return this.instance.post<MessageResponseDto>('/auth/email/change/cancel', dto).then(res => res.data);
  }

  public async passwordReset(dto: PasswordResetDto) {
    return this.instance.post<TokenResponseDto>('/auth/password-reset-link', dto).then(res => res.data);
  }

  public async refresh() {
    const refresh_token = localStorage.getItem('refresh_token');
    return this.instance.post<TokenResponseDto>('/auth/refresh', {
        refresh_token,
      },
    ).then(res => res.data);
  }

  public async getRoles() {
    return this.instance.get<RoleSummaryDto[]>('/roles').then(res => res.data);
  }

  public async registerWithInvite(dto: RegisterWithInviteDto) {
    return this.instance.post<TokenResponseDto>('auth/register-with-invite', dto).then(res => res.data);
  }
}

export type RegisterWithInviteDto = {
  username: string;
  email: string;
  password: string;
  invite_token: string;
}
export type RoleSummaryDto = {
  id: string
  name: string
  description: Nullable<string>
  enabled: boolean
  createdAt: IsoDate
  updatedAt: IsoDate
}
export type LoginDto = {
  username: string;
  password: string;
}

export type TokenResponseDto = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  toke_type: string;
}

export type PasswordResetDto = {
  token: string;
  // minLength: 8
  new_password: string
}

export type EmailChangeTokenDto = {
  token: string;
}

export type MessageResponseDto = {
  message: string
}
